export { default as OwnerPostsReducer } from './slice'
